export default __webpack_public_path__ + "static/media/ri_edit-line.fe1de7ed.svg";